// extracted by mini-css-extract-plugin
export default {"buttonSection":"ButtonSection_buttonSection__Ov7qc"};